export default {
      id: "ic_non_highlight-usage",
      viewBox: "1 1 17 22.5",
      url: "/" + "images/icons.3.109.2.svg#ic_non_highlight-usage",
      toString: function () {
        return this.url;
      }
    }